export default {
  getCurrentEvent: (state, getters) => (date, slug) => {
    console.log(slug)
    return getters.flatEvents.find(x => {
      return x.date === date && x.slug === slug
    })
  },

  childEvents: state => {
    if (state.events) {
      return state.events.map(x => x.events).flat()
    } else {
      return false
    }
  },

  flatEvents: (state, getters) => {
    return state.events.concat(getters.childEvents)
  },

  getEventsByArtistSlug: (state, getters) => (slug) => {
    let relatedEvents = []

    getters.childEvents.map(x => {
      x.artists.map(y => {
        if (y.slug === slug) {
          relatedEvents.push(x)
        }
      })
    })

    return relatedEvents
  }
}
